/* eslint-disable no-underscore-dangle */
import ReactMarkdown from 'react-markdown';
import { useSelector } from 'react-redux';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { FormContext } from '../../../customise/contexts/form-context';
import { assignFormDesignToCSSVars } from '../fields-customise.style';
import { selectCtrlIdLabelMap } from '../../selectors';
import { ControlPropType } from '../../ctrl_proptype';
import {
  MainfieldWrapper,
  DescriptionField,
  SubtextWrapper,
  FieldWrapper,
  Field,
} from '../../common-field-styles';

const Description = ({ ctrl, formDesign }) => {
  const ctrlIdLabelMap = useSelector(selectCtrlIdLabelMap);
  const fieldLabel = ctrlIdLabelMap?.[ctrl.internal_id];
  const { inBuilder } = useContext(FormContext);

  const markdownLabel = fieldLabel
  ?.replaceAll('<b style="color: #5972ce">', '**')
  ?.replaceAll('</b>', '**');
  
  return (
    <MainfieldWrapper style={assignFormDesignToCSSVars(inBuilder, formDesign)}>
      <FieldWrapper>
        <Field>
          <DescriptionField notInBuilder={!inBuilder}>
            <ReactMarkdown
              children={markdownLabel}
              className="pre-wrap"
              linkTarget="_blank"
            />
          </DescriptionField>

          <SubtextWrapper id="descriptive text">{ctrl.props.subtext}</SubtextWrapper>
        </Field>
      </FieldWrapper>
    </MainfieldWrapper>
  );
};

Description.defaultProps = {
  formDesign: null,
};

Description.propTypes = {
  ctrl: PropTypes.shape(ControlPropType).isRequired,
  formDesign: PropTypes.shape({
    old: PropTypes.object.isRequired,
    design: PropTypes.object.isRequired,
  }),
};
export default Description;
